// Paris-intent SEO landing pages (2/2).
const page = (en, fr) => ({ en, fr });

export const LANDINGS_PARIS_2 = {
  "corporate-concierge-paris": page(
    {
      seoTitle: "Corporate Concierge in Paris for Companies | Book & Smile",
      seoDesc: "A corporate concierge in Paris for foreign companies: client hospitality, executive visits, team events and employee assistance — one local partner.",
      eyebrow: "Corporate Concierge · Paris",
      h1a: "A corporate concierge",
      h1b: "for your company in Paris.",
      answer: "Book & Smile serves companies as a corporate concierge in Paris: client hospitality, executive visits, team events and employee assistance — one local partner under a single agreement, with monthly reporting and invoicing your finance team will like.",
      s: "Your company touches Paris regularly: clients to host, executives visiting, teams offsite, employees arriving or travelling.",
      c: "Each touchpoint is currently improvised by whoever has the least bandwidth — an office manager abroad, an EA at midnight, a local intern. The result is inconsistent, and it shows.",
      q: "What if every Paris touchpoint had the same reliable hands?",
      deliverablesTitle: "What we handle for companies",
      deliverables: [
        "Client hospitality — dinners, gifts, experiences that close relationships",
        "Executive visits — door-to-door coordination for leadership trips",
        "Team events — offsites, celebrations, board dinners",
        "Employee assistance — practical Paris support for staff and assignees",
        "Recurring presence — errands, deliveries, representation on demand",
        "One agreement — monthly reporting, consolidated invoicing",
      ],
      forTitle: "Who retains us",
      forWho: [
        "Foreign companies with clients or partners in Paris",
        "HR and workplace teams supporting travelling employees",
        "Executive offices needing a standing Paris capability",
      ],
      faqs: [
        { q: "How is the service invoiced?", a: "A monthly corporate arrangement or per-mission quotes — consolidated invoicing, monthly reporting, one contact for procurement." },
        { q: "Can employees contact you directly?", a: "Yes, within the scope your company defines. Usage is reported monthly." },
        { q: "Do you sign corporate NDAs and vendor agreements?", a: "Yes — NDAs, vendor onboarding and compliance documentation are standard." },
      ],
      waMsg: "Hello, I am interested in corporate concierge services in Paris for our company.",
    },
    {
      seoTitle: "Conciergerie d'entreprise à Paris | Book & Smile",
      seoDesc: "Une conciergerie d'entreprise à Paris : accueil de clients, visites de dirigeants, événements d'équipe et assistance aux collaborateurs — un partenaire local.",
      eyebrow: "Conciergerie d'entreprise · Paris",
      h1a: "Une conciergerie d'entreprise",
      h1b: "pour votre société à Paris.",
      answer: "Book & Smile sert les entreprises comme conciergerie corporate à Paris : accueil de clients, visites de dirigeants, événements d'équipe et assistance aux collaborateurs — un partenaire local sous un seul accord, avec reporting mensuel et facturation consolidée.",
      s: "Votre société touche Paris régulièrement : clients à recevoir, dirigeants en visite, équipes en séminaire, collaborateurs en déplacement.",
      c: "Chaque point de contact est aujourd'hui improvisé par la personne la moins disponible. Le résultat est inégal, et cela se voit.",
      q: "Et si chaque point de contact parisien passait par les mêmes mains fiables ?",
      deliverablesTitle: "Ce que nous gérons pour les entreprises",
      deliverables: [
        "Accueil clients — dîners, cadeaux, expériences qui scellent les relations",
        "Visites de dirigeants — coordination porte à porte",
        "Événements d'équipe — séminaires, célébrations, dîners de conseil",
        "Assistance collaborateurs — soutien pratique à Paris",
        "Présence récurrente — courses, livraisons, représentation à la demande",
        "Un accord unique — reporting mensuel, facturation consolidée",
      ],
      forTitle: "Qui nous retient",
      forWho: [
        "Sociétés étrangères avec clients ou partenaires à Paris",
        "Équipes RH soutenant des collaborateurs en déplacement",
        "Directions générales voulant une capacité parisienne permanente",
      ],
      faqs: [
        { q: "Comment est facturé le service ?", a: "Accord corporate mensuel ou devis par mission — facturation consolidée, reporting mensuel, un contact pour les achats." },
        { q: "Les collaborateurs peuvent-ils vous contacter directement ?", a: "Oui, dans le périmètre défini par votre société. L'usage est rapporté mensuellement." },
        { q: "Signez-vous NDA et contrats fournisseurs ?", a: "Oui — NDA, onboarding fournisseur et documentation de conformité sont standard." },
      ],
      waMsg: "Bonjour, je suis intéressé(e) par une conciergerie d'entreprise à Paris.",
    }
  ),

  "business-assistance-paris": page(
    {
      seoTitle: "Business & Corporate Assistance in Paris | Book & Smile",
      seoDesc: "Business assistance in Paris for foreign companies: welcoming clients, organising meetings, preparing trips, managing guests, coordinating events — on demand.",
      eyebrow: "For Business · Paris",
      h1a: "Business & corporate assistance",
      h1b: "in Paris.",
      answer: "Book & Smile gives foreign companies a local presence in Paris, on demand: welcoming clients, organising meetings, preparing business trips, managing guests, coordinating events and executing tasks locally — without hiring anyone.",
      s: "Your company needs Paris a few days a month: a meeting to host, a client to welcome, a document to sign, an event to run.",
      c: "Too little for a local hire; too important for improvisation. Flying someone in for logistics is expensive; asking a partner's assistant is awkward.",
      q: "What if your company simply had someone in Paris?",
      deliverablesTitle: "Your local presence, on demand",
      deliverables: [
        "Welcoming clients — received, hosted, accompanied in your name",
        "Organising meetings — venues, logistics, catering, follow-up",
        "Preparing business trips — everything ready before your team lands",
        "Managing guests — programmes, transfers, attention to detail",
        "Coordinating events — from board dinners to product launches",
        "Local tasks — signatures, documents, couriers, presence at appointments",
      ],
      forTitle: "Who retains us",
      forWho: [
        "Foreign companies without a Paris office",
        "Teams preparing recurring executive travel to France",
        "Firms hosting French clients and partners regularly",
      ],
      faqs: [
        { q: "Do we need a contract for a single mission?", a: "No — one-off missions run on a simple quote. Recurring needs fit a corporate arrangement with monthly reporting." },
        { q: "Can you work under our brand when receiving guests?", a: "Yes — discreetly, in your name, to your standard." },
        { q: "Which languages do you operate in?", a: "Native French and fluent English, with vetted interpreters coordinated for other languages." },
      ],
      waMsg: "Hello, our company is interested in business assistance in Paris.",
    },
    {
      seoTitle: "Assistance business & corporate à Paris | Book & Smile",
      seoDesc: "Assistance business à Paris pour sociétés étrangères : accueil de clients, organisation de rendez-vous, préparation de déplacements, gestion d'invités, événements.",
      eyebrow: "Entreprises · Paris",
      h1a: "Assistance business & corporate",
      h1b: "à Paris.",
      answer: "Book & Smile donne aux sociétés étrangères une présence locale à Paris, à la demande : accueillir des clients, organiser des rendez-vous, préparer des déplacements, gérer des invités, coordonner des événements et exécuter des tâches localement — sans recruter.",
      s: "Votre société a besoin de Paris quelques jours par mois : une réunion à tenir, un client à accueillir, un document à signer, un événement à organiser.",
      c: "Trop peu pour une embauche locale ; trop important pour l'improvisation. Envoyer quelqu'un pour la logistique coûte cher ; solliciter l'assistante d'un partenaire est délicat.",
      q: "Et si votre société avait simplement quelqu'un à Paris ?",
      deliverablesTitle: "Votre présence locale, à la demande",
      deliverables: [
        "Accueil de clients — reçus, accompagnés, en votre nom",
        "Organisation de rendez-vous — lieux, logistique, traiteur, suivi",
        "Préparation de déplacements — tout est prêt avant l'atterrissage",
        "Gestion d'invités — programmes, transferts, souci du détail",
        "Coordination d'événements — du dîner de conseil au lancement produit",
        "Tâches locales — signatures, documents, coursiers, présence aux rendez-vous",
      ],
      forTitle: "Qui nous retient",
      forWho: [
        "Sociétés étrangères sans bureau parisien",
        "Équipes préparant des déplacements dirigeants récurrents",
        "Entreprises recevant régulièrement clients et partenaires français",
      ],
      faqs: [
        { q: "Faut-il un contrat pour une mission unique ?", a: "Non — les missions ponctuelles fonctionnent sur simple devis. Les besoins récurrents relèvent d'un accord corporate avec reporting mensuel." },
        { q: "Pouvez-vous opérer sous notre marque ?", a: "Oui — discrètement, en votre nom, à votre standard." },
        { q: "Dans quelles langues opérez-vous ?", a: "Français natif et anglais courant, avec interprètes vérifiés pour les autres langues." },
      ],
      waMsg: "Bonjour, notre société est intéressée par une assistance business à Paris.",
    }
  ),

  "lifestyle-concierge-paris": page(
    {
      seoTitle: "Lifestyle Management in Paris — For Residents | Book & Smile",
      seoDesc: "Lifestyle management in Paris: restaurants, culture, shopping, wellness and bespoke experiences — for residents who want the city to work for them.",
      eyebrow: "Lifestyle Concierge · Paris",
      h1a: "Everyday Paris,",
      h1b: "elevated.",
      answer: "Book & Smile is a lifestyle concierge in Paris for people who live here: restaurants, cultural experiences, events, shopping, wellness and bespoke moments — woven into your weeks, not booked as exceptions.",
      s: "You live in one of the world's great cities. Its best evenings, exhibitions, tables and addresses renew themselves every week.",
      c: "Enjoying them requires the one thing residents lack: time to track, choose and book. So the city you moved for quietly becomes the city you commute through.",
      q: "When did you last enjoy Paris on a Tuesday?",
      deliverablesTitle: "Your Paris, curated",
      deliverables: [
        "Restaurants — a living shortlist matched to your taste, booked ahead",
        "Culture — exhibitions, premieres and openings, chosen for you",
        "Events — your social calendar, quietly maintained",
        "Shopping — personal shopping, sourcing, returns handled",
        "Wellness — trainers, spas, practitioners, vetted and booked",
        "Bespoke — anniversaries, surprises, moments designed once",
      ],
      forTitle: "Who retains us",
      forWho: [
        "Residents who want their city back",
        "Couples and families who outsource the planning, not the pleasure",
        "New arrivals who want Paris to open quickly",
      ],
      faqs: [
        { q: "Do you impose your taste?", a: "No — we learn yours. The first month calibrates; afterwards, suggestions feel like your own ideas, earlier." },
        { q: "Is this included in membership?", a: "Yes — lifestyle concierge is part of Executive and Private Office membership; Essential covers it on request." },
        { q: "Can you plan around children?", a: "Absolutely — family-friendly is a competence, not a compromise." },
      ],
      waMsg: "Hello, I am interested in a lifestyle concierge in Paris.",
    },
    {
      seoTitle: "Lifestyle management à Paris — pour résidents | Book & Smile",
      seoDesc: "Lifestyle management à Paris : restaurants, culture, shopping, bien-être et expériences sur mesure — pour les résidents qui veulent que la ville travaille pour eux.",
      eyebrow: "Conciergerie lifestyle · Paris",
      h1a: "Le Paris quotidien,",
      h1b: "élevé.",
      answer: "Book & Smile est une conciergerie lifestyle à Paris pour ceux qui y vivent : restaurants, expériences culturelles, événements, shopping, bien-être et moments sur mesure — tissés dans vos semaines, pas réservés comme des exceptions.",
      s: "Vous vivez dans l'une des plus grandes villes du monde. Ses meilleures soirées, expositions, tables et adresses se renouvellent chaque semaine.",
      c: "En profiter exige la seule chose qui manque aux résidents : le temps de suivre, choisir et réserver. La ville pour laquelle vous êtes venu devient celle que vous traversez.",
      q: "À quand remonte votre dernier Paris un mardi soir ?",
      deliverablesTitle: "Votre Paris, curaté",
      deliverables: [
        "Restaurants — une shortlist vivante selon vos goûts, réservée à l'avance",
        "Culture — expositions, premières et vernissages, choisis pour vous",
        "Événements — votre agenda social, discrètement entretenu",
        "Shopping — personal shopping, sourcing, retours gérés",
        "Bien-être — coachs, spas, praticiens, vérifiés et réservés",
        "Sur mesure — anniversaires, surprises, moments conçus une fois",
      ],
      forTitle: "Qui nous retient",
      forWho: [
        "Résidents qui veulent retrouver leur ville",
        "Couples et familles qui externalisent l'organisation, pas le plaisir",
        "Nouveaux arrivants qui veulent un Paris qui s'ouvre vite",
      ],
      faqs: [
        { q: "Imposez-vous vos goûts ?", a: "Non — nous apprenons les vôtres. Le premier mois calibre ; ensuite, les suggestions ressemblent à vos propres idées, en avance." },
        { q: "Est-ce inclus dans l'adhésion ?", a: "Oui — la conciergerie lifestyle fait partie des adhésions Executive et Private Office ; Essential la couvre à la demande." },
        { q: "Planifiez-vous avec des enfants ?", a: "Absolument — le family-friendly est une compétence, pas un compromis." },
      ],
      waMsg: "Bonjour, je suis intéressé(e) par une conciergerie lifestyle à Paris.",
    }
  ),

  "travel-concierge-paris": page(
    {
      seoTitle: "Travel Concierge in Paris — VIP Itineraries | Book & Smile",
      seoDesc: "A travel concierge for Paris and beyond: itineraries, private experiences, transport, events and VIP guest coordination — one contact, arrival to departure.",
      eyebrow: "Travel & Events · Paris",
      h1a: "Paris and beyond,",
      h1b: "coordinated.",
      answer: "Book & Smile is your travel concierge for Paris and beyond: itineraries designed around you, private experiences, transportation, events and VIP guest coordination — one contact from wheels-down to wheels-up.",
      s: "A trip to Paris carries expectations: the days should feel effortless, the evenings memorable, the logistics invisible.",
      c: "Guidebooks produce everyone's trip. Platforms produce inventory. And the coordination between hotel, driver, restaurant and museum belongs to no one — until something slips.",
      q: "Who owns your trip, end to end?",
      deliverablesTitle: "From arrival to departure",
      deliverables: [
        "Itineraries — days designed around your pace and interests",
        "Private experiences — guides, ateliers, tables, moments off the map",
        "Transportation — airport meet & greet, drivers, day trips beyond Paris",
        "Events — a birthday in a private salon, a proposal done properly",
        "VIP guest coordination — your guests handled to your standard",
        "One contact — reachable throughout the stay, adjusting in real time",
      ],
      forTitle: "Who retains us",
      forWho: [
        "International visitors who want Paris without logistics",
        "Hosts arranging stays for guests, family or clients",
        "Special occasions that must simply be perfect",
      ],
      faqs: [
        { q: "How far in advance should we book?", a: "Two to four weeks lets us secure the rare things; we also rescue trips on short notice — it is a speciality." },
        { q: "Do you cover outside Paris?", a: "Yes — Versailles, Champagne, the Loire, Normandy, Provence — with the same single point of contact." },
        { q: "Can you coordinate with our hotel?", a: "Seamlessly. We work alongside hotel teams, adding continuity and your file." },
      ],
      waMsg: "Hello, I am interested in travel and events coordination in Paris.",
    },
    {
      seoTitle: "Conciergerie voyage à Paris — invités VIP | Book & Smile",
      seoDesc: "Une conciergerie voyage pour Paris et au-delà : itinéraires, expériences privées, transports, événements et coordination d'invités VIP — de l'arrivée au départ.",
      eyebrow: "Voyages & Événements · Paris",
      h1a: "Paris et au-delà,",
      h1b: "coordonnés.",
      answer: "Book & Smile est votre conciergerie voyage pour Paris et au-delà : itinéraires conçus autour de vous, expériences privées, transports, événements et coordination d'invités VIP — un contact de l'atterrissage au décollage.",
      s: "Un voyage à Paris porte des attentes : des journées sans effort, des soirées mémorables, une logistique invisible.",
      c: "Les guides produisent le voyage de tout le monde. Les plateformes produisent de l'inventaire. Et la coordination entre hôtel, chauffeur, restaurant et musée n'appartient à personne — jusqu'à ce que quelque chose lâche.",
      q: "Qui porte votre voyage, de bout en bout ?",
      deliverablesTitle: "De l'arrivée au départ",
      deliverables: [
        "Itinéraires — des journées conçues à votre rythme",
        "Expériences privées — guides, ateliers, tables, moments hors carte",
        "Transports — accueil aéroport, chauffeurs, escapades hors Paris",
        "Événements — un anniversaire en salon privé, une demande faite comme il faut",
        "Coordination d'invités VIP — vos invités traités à votre standard",
        "Un contact — joignable pendant tout le séjour, ajustant en temps réel",
      ],
      forTitle: "Qui nous retient",
      forWho: [
        "Visiteurs internationaux qui veulent Paris sans logistique",
        "Hôtes organisant des séjours pour invités, famille ou clients",
        "Occasions spéciales qui doivent simplement être parfaites",
      ],
      faqs: [
        { q: "Combien de temps à l'avance réserver ?", a: "Deux à quatre semaines permettent de sécuriser le rare ; nous sauvons aussi des séjours au pied levé — c'est une spécialité." },
        { q: "Couvrez-vous hors de Paris ?", a: "Oui — Versailles, la Champagne, la Loire, la Normandie, la Provence — avec le même contact unique." },
        { q: "Coordonnez-vous avec notre hôtel ?", a: "En toute fluidité. Nous travaillons aux côtés des équipes hôtelières, en ajoutant la continuité et votre dossier." },
      ],
      waMsg: "Bonjour, je suis intéressé(e) par la coordination voyages et événements à Paris.",
    }
  ),

};
